import { IStyle } from '@fluentui/react';

import { Sizes } from '../../themes/styles';
export interface ICarouselStyles {
  root: IStyle;
  leftButtonContainer: IStyle;
  rightButtonContainer: IStyle;
  pagination: IStyle;
  container: IStyle;
  itemsContainer: IStyle;
  items: IStyle;
  item: IStyle;
}

const buttonContainerStyle: IStyle = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  position: 'absolute',
  height: '100%',
  top: 0,
};

const buttonPadding = 50;
export const gap = 10;

export const carouselStylesDefault: ICarouselStyles = {
  root: {
    position: 'relative',
    paddingBottom: 40, // pagination
    height: '100%',
    '&.single .h2o-Carousel-items': {
      minWidth: '100%',
    },
    '&.single .h2o-Carousel-item': {
      width: '100%',
    },
  },
  container: {
    height: '100%',
    padding: `0 ${buttonPadding}px`,
    position: 'relative',
  },
  leftButtonContainer: {
    ...buttonContainerStyle,
    left: 0,
  },
  rightButtonContainer: {
    ...buttonContainerStyle,
    right: 0,
  },
  pagination: {
    position: 'absolute',
    width: '100%',
    bottom: 0,
  },
  itemsContainer: {
    position: 'relative',
    height: '100%',
    width: '100%',
    overflow: 'hidden',
    borderRadius: Sizes.borderRadius,
  },
  items: {
    display: 'inline-flex',
    height: '100%',
    minWidth: 'max-content',
    position: 'absolute',
    left: 0,
    top: 0,
    transition: `transform 0.3s ease-in-out`,
  },
  item: {
    height: '100%',
    cursor: 'pointer',
    overflow: 'hidden',
    marginRight: gap,
    borderRadius: Sizes.borderRadius,
  },
};
